import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsViewsByDeviceTypeQuery } from "../graphql/queries";
import type {
  AnalyticsViewsByDeviceTypeQueryType,
  AnalyticsViewsByDeviceTypeQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsViewsByDeviceTypeQuery = (
  options?: QueryHookOptions<
    AnalyticsViewsByDeviceTypeQueryType,
    AnalyticsViewsByDeviceTypeQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsViewsByDeviceTypeQueryType,
    AnalyticsViewsByDeviceTypeQueryVariablesType
  >(AnalyticsViewsByDeviceTypeQuery, options);
};
